import {schemaTypes, dateFormat} from '../../../constants/constants';


const schema = {
    key:"cmd_status_report",
    name:"Command Status Report",
    toolbar:[
    ],
    content:[
        {
            key:"cmd_status_report",
            name:"Command Status Report",
            type:schemaTypes.CMD_STATUS_REPORT,
            position:{
                width:12,
                height:12,
                left:0,
                top:0
            },
        }
    ]
}
export default schema;